import { ColumnsType } from 'antd/es/table'
import { SortOrder } from 'antd/es/table/interface'
import { LeadByIndicator } from 'components/LeadByIndicator'
import { Sorter } from 'components/Sorter/Sorter'
import { Status } from 'components/Status'
import { timelineDateFormat } from 'components/Timelines/constants'
import { currencyFormatter } from 'features/ContractDetails/ContractDetailsGeneral/ContractDetailsForm/utils'
import {
  DISPUTE_STATUS_NAME,
  DISPUTE_STATUS_TO_CLASSNAME
} from 'features/Financials/constants'
import moment from 'moment'
import { InvoicesTableRecord } from '../types'
import { ReasonCell } from 'features/Financials/Rebates/RebatesTable/InvoicesDetailsPopup/InvoicesDetails/InvoicesTable/ReasonCell/ReasonCell'

export const columns: ColumnsType<InvoicesTableRecord> = [
  {
    dataIndex: 'supplier_invoice_number',
    key: 'supplier_invoice_number',
    width: 174,
    title: 'Supplier Invoice Number',
    sorter: false,
    showSorterTooltip: false
  },
  {
    dataIndex: 'dispute',
    key: 'dispute',
    width: 148,
    title: ({ sortOrder, sortColumn }) => (
      <Sorter<InvoicesTableRecord>
        dataIndex="dispute"
        sortColumn={sortColumn}
        sortOrder={sortOrder as SortOrder}
      >
        Dispute
      </Sorter>
    ),
    sorter: true,
    showSorterTooltip: false,
    render: (_, { dispute }) =>
      dispute?.dispute_type ? (
        <Status.Default
          className={DISPUTE_STATUS_TO_CLASSNAME[dispute.dispute_type]}
        >
          {DISPUTE_STATUS_NAME[dispute.dispute_type]}
        </Status.Default>
      ) : (
        '-'
      )
  },
  {
    dataIndex: 'dispute_reason',
    key: 'dispute_reason',
    width: 259,
    title: 'Dispute reason',
    sorter: false,
    showSorterTooltip: false,
    render: (_, { dispute }) =>
      dispute?.dispute_reason ? (
        <ReasonCell
          title="Dispute reason"
          trigger="click"
          reason={dispute.dispute_reason}
          text={dispute.dispute_reason}
        />
      ) : (
        '-'
      )
  },
  {
    dataIndex: 'led_by',
    key: 'led_by',
    width: 104,
    title: 'Led by',
    sorter: true,
    showSorterTooltip: false,
    render: (_, { led_by }) => (
      <span className="separate-item">
        {led_by ? <LeadByIndicator value={led_by} /> : '-'}
      </span>
    )
  },
  {
    dataIndex: 'contract_category_name',
    key: 'contract_category_name',
    width: 259,
    title: 'Contract category',
    sorter: false,
    showSorterTooltip: false
  },
  {
    dataIndex: 'invoice_date',
    key: 'invoice_date',
    width: 168,
    title: ({ sortOrder, sortColumn }) => (
      <Sorter<InvoicesTableRecord>
        dataIndex="invoice_date"
        sortColumn={sortColumn}
        sortOrder={sortOrder as SortOrder}
      >
        Invoice Date
      </Sorter>
    ),
    sorter: true,
    showSorterTooltip: false,
    render: (_, { invoice_date }) =>
      invoice_date ? moment(invoice_date).format(timelineDateFormat) : '-'
  },
  {
    dataIndex: 'invoice_amount',
    key: 'invoice_amount',
    width: 129,
    title: 'Invoice Amount, $',
    sorter: false,
    showSorterTooltip: false,
    render: (_, { invoice_amount }) => currencyFormatter(invoice_amount)
  }
]
